import { Box, Typography } from "@mui/material";

export const ScroreCard = ({ score }: { score: number | null }) => {
    return (
        <Box
            sx={{
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "warning.main",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                width: 45,
                height: 45,
                p: 0.5,
                gap: 0.2
            }}
        >
            <Typography variant="body2" color="warning.main">{score || 0}</Typography>
            <Typography variant="caption" color="text.secondary" fontSize={10}>/</Typography>
            <Typography variant="caption" color="text.secondary" fontSize={10}>25</Typography>
        </Box>
    );
}